import * as React from 'react'
import { useEffect, useState } from 'react'

import { useCommentsList } from './hooks'
import { Alert, Col, Row } from 'antd'
import { useStore, useUnit } from 'effector-react'
import { $userProfile, $userRole } from '../../../features/user'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons'
import {
  $commentsError,
  commentListMounted,
  commentListBackendUpdated,
  deleteComment,
  getCommentsByTypes,
} from './model'
import { role } from '../../../libs'
import { ErrorScreen } from '../../../shared/components/errorScreen/errorScreen'
import { Comment } from './types'

type Props = {
  entityType: string
  entityId: string
  types?: number[]
  columns?: number
}

export const mapAlertType = (type: number) => {
  switch (type) {
    case 0:
      return 'error'
      break
    case 1:
      return 'warning'
    case 2:
      return 'info'
    default:
      return 'success'
  }
}

export const CommentList = ({
  entityType,
  entityId,
  types,
  columns,
}: Props) => {
  const [localComments, setLocalComments] = useState<Comment[]>([])
  const hasCustomTypes = !!types

  const { comments: sharedComments } = useCommentsList(
    { entityType, entityId },
    hasCustomTypes,
  )
  const userRole = useStore($userRole)
  const userProfile = useStore($userProfile)
  const commentsError = useUnit($commentsError)

  const fetchByTypes = () => {
    if (!types || !entityId) return
    const typeStr = `[${types.join(',')}]`
    getCommentsByTypes({
      url: `/comment?where={"entityType":"${entityType}", "entityId":"${entityId}", "type":${typeStr}}`,
    } as any).then((result: any) => {
      const sorted = [...result.body].sort(
        (a: Comment, b: Comment) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      )
      setLocalComments(sorted)
    })
  }

  useEffect(() => {
    if (hasCustomTypes) {
      fetchByTypes()
    }
  }, [entityType, entityId])

  useEffect(() => {
    if (hasCustomTypes) {
      const unsub = commentListBackendUpdated.watch(() => fetchByTypes())
      return unsub
    }
  }, [entityType, entityId])

  const comments = hasCustomTypes ? localComments : sharedComments
  const colSpan = columns ? Math.floor(24 / columns) : 24

  if (!hasCustomTypes && ![0, 404, null].includes(commentsError?.code || null)) {
    return (
      <ErrorScreen
        showRetry
        onRetry={() => {
          commentListMounted({
            entityType,
            entityId,
          })
        }}
      />
    )
  }

  return (
    <Row gutter={24} style={{ width: '100%' }}>
      {comments.map((comment) => {
        return (
          <Col xs={colSpan} key={comment.commentId}>
            <div className="position-relative">
              <Alert
                className="mb-2"
                message={comment.message}
                description={
                  (comment.user?.username || 'No information about user') +
                  ' / ' +
                  comment.humanCreatedAt
                }
                type={mapAlertType(comment.type)}
              />
              {(userRole?.includes(role.root()) ||
                userProfile.id === comment.user?.id) && (
                <CIcon
                  className="position-absolute text-danger"
                  style={{ top: '5px', right: '5px' }}
                  role="button"
                  icon={cilX}
                  onClick={() => deleteComment({ id: comment.commentId })}
                />
              )}
            </div>
          </Col>
        )
      })}
    </Row>
  )
}
